var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFishIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120.2 125.4",
    enableBackground: "new 0 0 120.2 125.4",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#43BBD5",
    d: "M112.3,46.5c-6.6-23.3-29.4-41-54.2-38.1c-0.1-0.2-0.3-0.2-0.6-0.2c-22.6,2.4-41,18.8-47.8,40.1 c-0.8,2.7-1.5,5.4-2,8.2c-0.2,0.1-0.2,0.4-0.1,0.5c-0.2,1-0.3,2-0.4,3c-0.1,0.1-0.1,0.2,0,0.3C6.3,67.6,6.7,75,8.8,82.1 c0.8,2.9,2,5.6,3.4,8.1c0,0.2,0.1,0.4,0.3,0.5c3.8,6.5,9.4,11.7,16,16c9.8,6.4,20.5,10.7,32.4,10.6c1.3,0,2.6-0.1,3.9-0.2 c0.2,0.2,0.7,0.2,0.8-0.1c8.9-0.9,17.7-4,25.3-8.7c9.9-6.2,17-14.6,20.6-25.7C115.1,70.9,115.6,58.2,112.3,46.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 63.8306,
    y1: 58.4523,
    x2: 114.0497,
    y2: 85.7307
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06666187,
    style: {
      stopColor: "#27646D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2401,
    style: {
      stopColor: "#2C7A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5857,
    style: {
      stopColor: "#3BA7BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7558,
    style: {
      stopColor: "#43BBD5"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M113.1,49.6l-14.4-5.9L94,49.5L65,37.9L53.5,88.5l41.1,17.2c7.9-5.9,13.7-13.5,16.8-23.1 C114.8,72,115.5,60.4,113.1,49.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M48.7,43c0,0,5.2-8.5,15.7-3.9c0,0-4.3,1.9-5.3,3.9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M48.7,82.7c1.9,2.3,7.3,7.2,15.7,3.5c0,0-3.2-1.7-4.9-3.5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M30.3,50.8c0,0-13.6,8.3-4.5,19.4c0,0,13.3,15,32.3,12.8c0,0,12.6-1.9,21-12l6.5-8.3c0,0-5-7.5-9.6-11.2c0,0-11.3-11.5-28.7-8.5 C47.4,43,39.2,44.2,30.3,50.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M98.5,44.1c0,0-17.7,3.2-12.6,18.6C85.9,62.6,100.1,62.3,98.5,44.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M98.5,81.2c0,0-17.7-3.2-12.6-18.6C85.9,62.6,100.1,62.9,98.5,81.2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#43BBD5",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M43.3,44.1c0,0,12.7,11.8-1.1,30.7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#43BBD5",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M51.3,58.3c0,0,3.5-3.1,7.5-2.1c0,0,5.7,1-1.2,7.6c0,0,2.8,6-2.6,6.2c0,0-3.7-0.1-5.7-0.8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#43BBD5",
    cx: 36.6,
    cy: 58.3,
    r: 2.3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#43BBD5",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M81,64.2c0,0-4,7.9-16.1,14.4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFishIcon);
export default __webpack_public_path__ + "static/media/fish_icon.0382bd01bac60e8f64429141c42420f3.svg";
export { ForwardRef as ReactComponent };